angular.module('TetherApp').factory('clientService', [
    '$http',
    function($http) {
        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getClient = function () {
            let uri = '/api/v1/client/current/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(uri, {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        let getClientLanguages = function (clientId) {
            if (! clientId) {
                return [];
            }
            let uri = '/api/v1/client/' + clientId + '/client-languages/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(uri, {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        let setClient = function (clientId, clientName) {
            let uri = '/api/v1/clients/switcher/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.post(uri,
                {
                    client_id: clientId,
                    client_name: clientName
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            ).then(function (response) {
                return response.data;
            });
        };

        let getUsersClients = function () {
            let uri = '/api/v1/clients/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(uri, {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        let setSelectedClient = function (data) {
            return $http.post('/home/client', {client: data, redirect: false}, {
                cache: false,
                headers: { 'Cache-control': 'no-cache' }
            }).then(function (response) {
                return response.data
            });
        };

        let getClientShortcode = function () {
            let uri = '/api/v1/client/shortcode/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(uri, {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        let reset = function (clientId) {
            if (!clientId) {
                return [];
            }

            let uri = '/api/v1/client/' + clientId + '/reset/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.post(uri, {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        return {
            getClient: getClient,
            setClient: setClient,
            getUsersClients: getUsersClients,
            setSelectedClient: setSelectedClient,
            getClientShortcode: getClientShortcode,
            getClientLanguages: getClientLanguages,
            reset: reset
        }
    }
]);
